"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezoneOffset = exports.getCurrentTimezone = void 0;
var Helper = __importStar(require("firefly-utilities-helper-ts"));
function getCurrentTimezone() {
    var result = '';
    /* --- Update by Praxis team : Start --- */
    // const timeZoneString: string = Helper.getSystemDate().toTimeString(); //.toLocaleTimeString('en-us', { timeZoneName: 'short' });
    var timeZoneString = Helper.getSystemDate().toLocaleTimeString('en-us', { timeZoneName: 'short' });
    /* --- Update by Praxis team : End --- */
    if (Helper.isString(timeZoneString)) {
        var timeValues = timeZoneString.split(' ');
        if (timeValues.length > 2) {
            result = timeValues[2];
        }
    }
    return result;
}
exports.getCurrentTimezone = getCurrentTimezone;
function getTimezoneOffset() {
    var result = 0;
    var timeZoneOffset = Helper.getSystemDate().getTimezoneOffset();
    if (Helper.isNumber(timeZoneOffset)) {
        result = timeZoneOffset;
    }
    return result;
}
exports.getTimezoneOffset = getTimezoneOffset;
